module.exports = __webpack_public_path__ + "img/header.5b4aed98.svg";